import Vue from "vue";

export default Vue.extend({
  data(): { value: boolean } {
    return {
      value: false,
    };
  },

  methods: {
    getValidationState(failed: boolean, errors: Array<string>): boolean | null {
      return failed ? (errors.length === 0 ? null : false) : null;
    },

    getFirstError(errors: Array<string>): string | null {
      return errors.length > 0 ? errors[0] : null;
    },
  },
});
